<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Form-->
<div class="MainGrid2Col">
	<label>Group:</label>
	<label class="InfoText">{{ GroupName }}</label>

	<label>Prompt Type:</label>
	<select class="form-control" [(ngModel)]="SelectedPromptTypeID">
		<option *ngFor="let r of lstPromptType" [ngValue]="r.ID">
			{{ r.Desc }}
		</option>
	</select>

	<label>Release Type:</label>
	<select [disabled]="true" class="form-control" [(ngModel)]="ReleaseTypeID">
		<option *ngFor="let r of lstReleaseType" [ngValue]="r.ReleaseTypeID">
			{{ r.ReleaseTypeDesc }}
		</option>
	</select>

	<label>Admit Time:</label>
	<p-calendar
		[disabled]="EnableAdmitTime() == false"
		showTime="true"
		timeOnly="true"
		hourFormat="12"
		showIcon="true"
		showButtonBar="true"
		[(ngModel)]="AdmitTime"
		name="AdmitTime"
	></p-calendar>

	<label>Release Time:</label>
	<p-calendar
		[disabled]="EnableReleaseTime() == false"
		showTime="true"
		timeOnly="true"
		hourFormat="12"
		showIcon="true"
		showButtonBar="true"
		[(ngModel)]="ReleaseTime"
		name="ReleaseTime"
	></p-calendar>

	<label>Start Date:</label>
	<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="StartDate" name="StartDate"></p-calendar>

	<label>End Date:</label>
	<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="EndDate" name="EndDate"></p-calendar>

	<label>Only Show Excuses That Count As Present:</label>
	<input class="form-control ExcuseCHK" type="checkbox" [(ngModel)]="OnlyShowPresent" (ngModelChange)="onShowPresentChange($event)" />

	<label>Excuse:</label>
	<select class="form-control" [(ngModel)]="ExcuseID">
		<option *ngFor="let r of lstExcuse" [ngValue]="r.ExcuseID">
			{{ r.ExcuseDesc }}
		</option>
	</select>

	<label>Reason:</label>
	<textarea [(ngModel)]="Comment" rows="5" class="TextArea"></textarea>

	<label>Select the Day(s):</label>
	<div class="DayGrid">
		<input name="MonCheck" id="MonCheck" [(ngModel)]="MonCheck" class="form-control NoMargin CHKWidth" type="checkbox" />
		<label for="MonCheck">Monday</label>

		<input name="TueCheck" id="TueCheck" [(ngModel)]="TueCheck" class="form-control NoMargin CHKWidth" type="checkbox" />
		<label for="TueCheck">Tuesday</label>

		<input name="WedCheck" id="WedCheck" [(ngModel)]="WedCheck" class="form-control NoMargin CHKWidth" type="checkbox" />
		<label for="WedCheck">Wednesday</label>

		<input name="ThuCheck" id="ThuCheck" [(ngModel)]="ThuCheck" class="form-control NoMargin CHKWidth" type="checkbox" />
		<label for="ThuCheck">Thursday</label>

		<input name="FriCheck" id="FriCheck" [(ngModel)]="FriCheck" class="form-control NoMargin CHKWidth" type="checkbox" />
		<label for="FriCheck">Friday</label>

		<input name="SatCheck" id="SatCheck" [(ngModel)]="SatCheck" class="form-control NoMargin CHKWidth" type="checkbox" />
		<label for="SatCheck">Saturday</label>

		<input name="SunCheck" id="SunCheck" [(ngModel)]="SunCheck" class="form-control NoMargin CHKWidth" type="checkbox" />
		<label for="SunCheck">Sunday</label>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
